module.exports = __webpack_public_path__ + "img/Squarespace.838909fb.svg";